import Uploader from './s3-multi-uploader.vue';
export default Uploader;
